<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-toolbar class="mb-2 pa-0" color="primary" dark flat>
          <v-toolbar-title>{{ grafTitle }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="2">
        <v-autocomplete
          label="Lokalita"
          v-model="filterLokalitaId"
          :items="lokality"
          item-text="Name"
          item-value="ID"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <date-picker
          v-model="filterDatumOd"
          label="Dátum od"
          name="filterDatumOd"
        ></date-picker>
      </v-col>
      <v-col cols="2">
        <date-picker
          v-model="filterDatumDo"
          label="Dátum do"
          name="filterDatumDo"
        ></date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-autocomplete
          label="Bod HPV"
          v-model="filterBodHpvId"
          :items="bodyHpv"
          item-text="ZNMB"
          item-value="ID"
          ref="acBod"
          clearable
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          label="Bod Q"
          v-model="filterBodQId"
          :items="bodyQ"
          item-text="ZNMB"
          item-value="ID"
          ref="acBod"
          clearable
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          label="Bod Ink"
          v-model="filterBodInkId"
          :items="bodyInk"
          item-text="ZNMB"
          item-value="ID"
          ref="acBod"
          clearable
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          label="Bod Geo"
          v-model="filterBodGeoId"
          :items="bodyGeo"
          item-text="ZNMB"
          item-value="ID"
          ref="acBod"
          clearable
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          label="Stanica SHMÚ"
          v-model="filterStanicaId"
          :items="stanice"
          item-text="Stanica"
          item-value="ID"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-btn @click="show()" :loading="loading" :disabled="loading"
          >Zobraziť graf</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-if="grafData.length > 0">
      <v-col cols="12">
        <bar-chart
          :chart-data="grafValues()"
          :options="grafOptions()"
        ></bar-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Miscella from "../plugins/miscella.js"
//import * as Colors from "../plugins/colors.js"
import DatePicker from "../components/DatePicker.vue"
import BarChart from "../components/charts/BarChart.js"

export default {
  data: function() {
    return {
      loading: false,
      filterLokalitaId: "",
      filterDatumOd: "",
      filterDatumDo: "",
      filterBodHpvId: "",
      filterBodQId: "",
      filterBodInkId: "",
      filterBodGeoId: "",
      filterStanicaId: "",
      grafData: [],
      lokality: [],
      stanice: [],
      bodyHpv: [],
      bodyQ: [],
      bodyInk: [],
      bodyGeo: []
    }
  },
  components: { DatePicker, BarChart },
  props: {},
  computed: {
    grafTitle: function() {
      return "Grafy - Porovnávanie jednotlivých metód"
    }
  },
  watch: {
    filterLokalitaId: {
      immediate: true,
      handler: function() {
        this.filterBodHpvId = ""
        this.filterBodQId = ""
        this.filterBodInkId = ""
        this.filterBodGeoId = ""
        this.bodyInk = []
        this.bodyQ = []
        this.bodyHpv = []
        this.bodyGeo = []
        this.readBodyInk()
        this.readBodyQ()
        this.readBodyHpv()
        this.readBodyGeo()
      }
    }
  },
  methods: {
    readLokality: async function() {
      try {
        this.lokality = []
        let response = await this.$axios.get("/r/lokality")
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBodyInk: async function() {
      try {
        this.bodyInk = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/mer_inkp"
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.bodyInk = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBodyQ: async function() {
      try {
        this.bodyQ = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/mer_q"
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.bodyQ = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBodyHpv: async function() {
      try {
        this.bodyHpv = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/mer_hpv"
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.bodyHpv = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBodyGeo: async function() {
      try {
        this.bodyGeo = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/mer_geo"
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.bodyGeo = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readStanice: async function() {
      try {
        this.stanice = []
        let response = await this.$axios.get("/r/stanice")
        if (response.status === 200) {
          this.stanice = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    grafValues: function() {
      let ret = ""
      let datasets = []
      this.grafData.forEach(item => {
        let dataset = {}
        if (item.Popis.startsWith("SHM")) {
          dataset = {
            label: item.Popis,
            backgroundColor: "#00ffdd",
            borderWidth: 0,
            data: item.Items.map(function(i) {
              return { t: i.Datum, y: i.Hodnota }
            }),
            yAxisID: "y-axis-zrazky"
          }
        }
        if (item.Popis.startsWith("HPV")) {
          dataset = {
            label: item.Popis,
            type: "line",
            backgroundColor: "#0000ff",
            borderColor: "#0000ff",
            pointRadius: "0",
            borderWidth: "1",
            pointStyle: "line",
            fill: false,
            data: item.Items.map(function(i) {
              return { t: i.Datum, y: i.Hodnota }
            }),
            yAxisID: "y-axis-hpv"
          }
        }
        if (item.Popis.startsWith("Q")) {
          dataset = {
            label: item.Popis,
            type: "line",
            backgroundColor: "#00bfff",
            borderColor: "#00bfff",
            pointRadius: "0",
            borderWidth: "1",
            pointStyle: "line",
            fill: false,
            data: item.Items.map(function(i) {
              return { t: i.Datum, y: i.Hodnota }
            }),
            yAxisID: "y-axis-q"
          }
        }
        if (item.Popis.startsWith("Geo")) {
          dataset = {
            label: item.Popis,
            type: "line",
            backgroundColor: "#0e7265",
            borderColor: "#0e7265",
            pointRadius: "0",
            borderWidth: "1",
            pointStyle: "line",
            fill: false,
            data: item.Items.map(function(i) {
              return { t: i.Datum, y: i.Hodnota }
            }),
            yAxisID: "y-axis-geo"
          }
        }
        if (item.Popis.startsWith("Prenosn")) {
          dataset = {
            label: item.Popis,
            type: "line",
            backgroundColor: "#2aff00",
            borderColor: "#2aff00",
            pointRadius: "0",
            borderWidth: "1",
            pointStyle: "line",
            fill: false,
            data: item.Items.map(function(i) {
              return { t: i.Datum, y: i.Hodnota }
            }),
            yAxisID: "y-axis-ink"
          }
        }
        datasets.push(dataset)
      })
      ret = {
        datasets: datasets
      }
      console.log("grafValues", ret)
      return ret
    },
    grafOptions: function() {
      let ret = ""
      ret = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          //display: false
        },
        title: {
          //display: false
        },
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                unit: "month"
              }
            }
          ],
          yAxes: [
            {
              type: "linear",
              display: "auto",
              id: "y-axis-zrazky",
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "[mm]"
              }
            },
            {
              type: "linear",
              display: "auto",
              id: "y-axis-hpv",
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "[m]"
              }
            },
            {
              type: "linear",
              display: "auto",
              id: "y-axis-q",
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "[l/min]"
              }
            },
            {
              type: "linear",
              display: "auto",
              id: "y-axis-ink",
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "[mm]"
              }
            },
            {
              type: "linear",
              display: "auto",
              id: "y-axis-geo",
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "[mm]"
              }
            }
          ]
        }
      }
      return ret
    },
    urlFetch: function() {
      let url = "/r/chart/komb?"
      url +=
        "datumOd=" + Miscella.formatDatumEx(this.filterDatumOd, "YYYY-MM-DD")
      url +=
        "&datumDo=" + Miscella.formatDatumEx(this.filterDatumDo, "YYYY-MM-DD")
      url += "&bodHpvID=" + Miscella.normalizeString(this.filterBodHpvId)
      url += "&bodQID=" + Miscella.normalizeString(this.filterBodQId)
      url += "&bodInkID=" + Miscella.normalizeString(this.filterBodInkId)
      url += "&bodGeoID=" + Miscella.normalizeString(this.filterBodGeoId)
      url += "&stanicaID=" + Miscella.normalizeString(this.filterStanicaId)
      return url
    },
    show: async function() {
      this.grafData = []
      try {
        console.log("show")
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          this.grafData = response.data.data
          /*
          this.grafData.push(response.data.hpvItems)
          this.grafData.push(response.data.qItems)
          this.grafData.push(response.data.inkItems)
          this.grafData.push(response.data.geoItems)
          this.grafData.push(response.data.shmuItems)
          */
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    }
  },
  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokality()
    this.readStanice()
  }
}
</script>
